import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Avatar,
} from "@material-ui/core";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(4),
  },
}));

export default function ErrorCard({ error }) {
  const classes = useStyles();
  debugger;

  return (
    <Card className={classes.root}>
      <CardHeader
        title={<Typography variant="h6">Error</Typography>}
        color="error"
        avatar={
          <Avatar className={classes.avatar}>
            <ErrorOutlineOutlinedIcon />
          </Avatar>
        }
      />
      <CardContent>
        <Typography color="error">{error}</Typography>
      </CardContent>
    </Card>
  );
}
